// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d7b31113","732":"12e3c2fa"}[chunkId] + ".chunk.js";
};